import { render, staticRenderFns } from "./DialogModal.vue?vue&type=template&id=6e428344&scoped=true&"
import script from "./DialogModal.vue?vue&type=script&lang=js&"
export * from "./DialogModal.vue?vue&type=script&lang=js&"
import style0 from "./DialogModal.vue?vue&type=style&index=0&id=6e428344&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e428344",
  null
  
)

export default component.exports